import React, { useState, useEffect } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import Header from "../../components/Header";
import FooterTwo from "../../components/Footer/FooterTwo";
import PartnerService from "../../services/partners.service";

const media = [
  { logoUrl: "/img/Media/1.JPG" },
  { logoUrl: "/img/Media/2.jpg" },
  { logoUrl: "/img/Media/3.png" },
  { logoUrl: "/img/Media/4.png" },
  { logoUrl: "/img/Media/5.jpg" },
  { logoUrl: "/img/Media/6.jpg" },
  { logoUrl: "/img/Media/7.png" },
  { logoUrl: "/img/Media/8.jpg" },
  { logoUrl: "/img/Media/9.jpg" },
  { logoUrl: "/img/Media/10.png" },
  { logoUrl: "/img/Media/11.png" },
  { logoUrl: "/img/Media/12.png" },
  { logoUrl: "/img/Media/13.png" },
  { logoUrl: "/img/Media/14.png" },
];

const Media = () => {
  const [awardList, setAwardList] = useState([]);

  useEffect(() => {
    PartnerService.awardList()
      .then((res) => setAwardList(res.data))
      .catch((err) => console.log(err));
  }, []);
  return (
    <>
      <Header topbarEnable="enable" />
      <Breadcrumb pageTitle={"Media Coverage"} />
      <section className="container py-5">
        <p className="col-10 m-auto my-5 text-center fs-5">
          Ocfit has been prominently featured across various media platforms for
          its outstanding contributions to education and community service. Our
          consistent recognition through multiple awards highlights the trust
          and respect we've earned in the industry. These media spotlights
          celebrate our mission to empower individuals and uplift
          communities—showcasing the real-world impact of our initiatives and
          our unwavering commitment to making a difference.
        </p>
        <div className="row row-cols-2 row-cols-md-3 g-md-5 g-3 mb-5">
          {media?.map((item, idx) => (
            <>
              <div key={idx} className="col">
                <div className="awards_card shadow ">
                  <img
                    src={item?.logoUrl}
                    width={102}
                    height={102}
                    style={{
                      objectFit: "cover",
                      height: "100%",
                      width: "100%",
                    }}
                    className="img-fluid  rounded"
                  />
                </div>
              </div>
            </>
          ))}
        </div>
      </section>
      <FooterTwo />
    </>
  );
};

export default Media;
